module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 154.4b55ba3b.png";